<!--
 * @Author: ZhaoG
 * @Date: 2026-03-05 14:54:00
 * @LastEditors: ZhaoG
 * @LastEditTime: 2026-03-26 14:04:26
 * @FilePath: \sra-fe\src\views\register\material\maPerfectInfo\addGreenProductsPreview.vue
 * @Description:绿色产品列表
-->
<template>
  <div class="content">
    <div class="tableBox">
      <el-table :data="tableData" border style="width: 100%">
        <!-- 产品名称 -->
        <el-table-column :label="$t('page.greenLowCarbon.table.isGreenProduction')" align="center" show-overflow-tooltip prop="productName">
        </el-table-column>

        <!-- 是否是绿色产品认证 -->
        <el-table-column :label="$t('page.greenLowCarbon.table.isGreenProductCertification')" align="center"
          prop="greenCertificationFlag">
          <template slot-scope="scope">
            {{
              scope.row.greenCertificationFlag == "1"
                ? $t("page.greenLowCarbon.contentLabel.isYes")
                : $t("page.greenLowCarbon.contentLabel.isNo")
            }}
          </template>
        </el-table-column>

        <!-- 绿色产品认证星级 -->
        <el-table-column :label="$t('page.greenLowCarbon.table.greenProductCertificationRating')
          " prop="greenCertificationLevel" align="center">
        </el-table-column>

        <!-- 对应的【绿色产品认证证书/绿色产品标识】附件名称 -->
        <el-table-column prop="greenProductCertificationFileName" :label="$t('page.greenLowCarbon.table.greenProductCertificationFileName')
          ">
          <template slot-scope="scope">
            <el-button type="text" @click="handleFileView(scope.$index, scope.row, 'green')"
              :disabled="scope.row.greenCertificationFiles.length == 0">{{ $t("page.greenLowCarbon.table.view") }}</el-button>
          </template>
        </el-table-column>

        <!-- 是否进行了产品碳足迹核算 -->
        <el-table-column :label="$t('page.greenLowCarbon.table.ProductCarbonFootprintAccounting')
          " prop="carbonFootstepFlag" align="center">
          <template slot-scope="scope">
            {{
              scope.row.carbonFootstepFlag == "1"
                ? $t("page.greenLowCarbon.contentLabel.isYes")
                : $t("page.greenLowCarbon.contentLabel.isNo")
            }}
          </template>
        </el-table-column>

        <!-- 产品碳足迹数值 -->
        <el-table-column :label="$t('page.greenLowCarbon.table.ProductCarbonFootprintValue')" align="center"
          prop="carbonFootstepValue">
        </el-table-column>

        <!-- 对应的【绿色产品认证证书/绿色产品标识】附件名称 -->
        <el-table-column prop="ProductCarbonFootprintFileName" :label="$t('page.greenLowCarbon.table.ProductCarbonFootprintFileName')
          ">
          <template slot-scope="scope">
            <el-button type="text" @click="handleFileView(scope.$index, scope.row, 'clean')"
              :disabled="scope.row.carbonFootstepFiles.length == 0">{{ $t("page.greenLowCarbon.table.view") }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 文件列表弹窗 -->
    <FileListDialog :dialogFormVisible.sync="fileDialogVisible" :file-list="currentFileList" title="附件文件列表"
      @handlePreview="previewFile" @handleClose="handleClose"  />
  </div>
</template>

<script>
import { getPreviewUrl } from "@/utils";
import FileListDialog from "./FileListDialog.vue";

export default {
  props: {
    temGreenInfo: {
      type: Array,
      default: () => []
    }
  },
  components: { FileListDialog },

  data() {
    let baseUrl = this.$addUrlPerFix(process.env.VUE_APP_BASE_URL);
    return {
      defaultData: [],
      tableData: [
        {
          greenCertificationFlag: "1",
          productName: "",
          carbonFootstepFlag: "1"
        }
      ],
      uploadUrl: baseUrl + "/apis/crma/oss/users/signup/uploadFilePersNew", //上传图片
      uploadLoading: null,
      fileList: [],
      fileLists: [],
      greenCertificationFiles: [],
      carbonFootstepFiles: [],
      rowId: "",
      index: 0,
      visibleIndex: 0,
      materialDirectoryShow: false, // 是否显示物料目录弹窗
      dialogFormVisible: false, // 是否显示物料目录弹窗
      selectData: [], // 选择的数据
      opUnitId: "0",
      materialDirectoryType: 2, //1是多选2是单选
      shebeioryunshu: "", //tran为运输设备物资
      fileDialogVisible: false, // 文件列表弹窗显示状态
      currentFileList: [], // 当前展示的文件列表
    };
  },
  watch: {
    temGreenInfo: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          newVal.forEach(item => {
            item.productName =
              item.matcateryNameMid + "-" + item.matcateryNameSmall;
          });
          this.tableData = JSON.parse(JSON.stringify(newVal));
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {

  },
  methods: {

    handleClose() {
      this.fileDialogVisible = false;
    },
    // 查看文件列表
    handleFileView(index, row, type) {
      this.currentRowIndex = index;
      this.currentFileType = type;
      // 根据碳足迹文件或绿色认证文件决定展示哪个列表
      if (type == "clean") {
        this.currentFileList = row.carbonFootstepFiles
      } else {
        this.currentFileList = row.greenCertificationFiles
      }
      this.fileDialogVisible = true;
    },


    //预览
    async previewFile({ uploadId,uploadIdStr }) {
      if (uploadIdStr) {
        getPreviewUrl(uploadIdStr);
      }else{
        getPreviewUrl(uploadId);
      }
    },

    // 下载文件
    downloadFile(row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${this.$addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/sra/reg/users/signup/downloadByFileUrl?fileUrl=${
        row.ossUrl
      }&fileName=${encodeURIComponent(row.fileName)}`;
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    },


  }
};
</script>

<style scoped lang="scss">
.content {
  padding: 20px;

  .btn {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
  }

  /deep/ .el-radio {
    margin-right: 10px;
  }
}
</style>
